
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.status {

  display: flex;

  height: 1.5rem;

  width: -moz-fit-content;

  width: fit-content;

  align-items: center;

  justify-content: space-between;

  border-radius: 1rem;

  padding-top: 1px;

  padding-bottom: 1px;

  padding-left: 0.5rem;

  padding-right: 0.5rem;

  color: var(--neutral-white);
}

  .status.show-value {

  min-width: 70px
}

  .status.hidden-value {

  padding: 0.3rem
}

  .status.hidden-value span {

  display: none
}

  .status.increased, .status.on-track {

  background-color: var(--green-quality-darken-2)
}

  .status.steady, .status.on-watch {

  background-color: var(--performance-orange)
}

  .status.decreased, .status.off-track {

  background-color: var(--status-error)
}

  .status.monitor {

  background-color: var(--performance-gray)
}

  .status.unset {

  background-color: var(--status-error)
}

  .status.coming-soon {

  background-color: var(--performance-blue)
}

  .status span {

  margin-top: 0px;

  margin-bottom: 0px
}

  .status span {

  margin-left: 0.25rem;

  margin-right: 0.25rem
}

  .status span {

  width: 50%
}

  .status span {

  font-weight: var(--fw-semibold)
}
`;